export const NON_REMOVABLE_TAGS = ["Day", "App", "Site"];

// Location-based tag types
export const LOCATION_TAG_TYPES = {
  FLOOR: "Floor",
  AREA: "Area",
  SUBAREA: "Subarea"
};

// Other tag types
export const TAG_TYPES = {
  OBJECT: "Object"
};
